<template>
    <div>
        <slotmanagement-core-app-bar :flights_dateRange="flights_dateRange" />
        <v-container
            id="overviews"
            ref="containerref"
            style="height:100%;background-image:radial-gradient(at 0% 0%, rgba(var(--color-secondary-500) / 0.33) 0px, transparent 50%),
                radial-gradient(at 98% 1%, rgba(var(--color-error-500) / 0.33) 0px, transparent 50%)"
            fluid>
            <div :id="id" :class="{ clicked: clicked, dragdiv: !clicked }">
                <div class="background" />
                <div class="foreground">
                    {{ dragItem }}
                </div>
            </div>

            <!-- Slots Table -->
            <div class="table_headline">
                Slots Table
            </div>
            <v-row
                ref="slotstablecontainerref"
                style="height:20vh;position:relative;"
                :style="{ height: topHeight + '%' }">
                <v-col style="overflow-y:auto;overflow-x:hidden;height:100%;padding-top:0px;">
                    <sdr-slotmanagement-slots-table :smallScreen="!$isDesktop()" />
                    <!-- --IN BEARBEITUNG-- -->
                </v-col>
                <v-speed-dial
                    v-if="showSlotsSpeedDial"
                    v-model="fabSlotsSpeedDial"
                    open-on-hover
                    style="position:absolute;bottom:30px;right:50px;z-index:1;">
                    <template v-slot:activator>
                        <v-btn
                            v-model="fabFlightsSpeedDial"
                            style="position:relative;"
                            color="primary"
                            fab>
                            <v-icon v-if="fabSlotsSpeedDial">
                                mdi-close
                            </v-icon>
                            <v-icon v-else>
                                mdi-plus
                            </v-icon>
                            <div class="flightsTable_selectedFlightsCounter">
                                {{ get_SlotsTable_SelectedSlots.length }}
                            </div>
                        </v-btn>
                    </template>

                    <v-btn
                        fab
                        small
                        class="mr-6"
                        @click="onClick_slotsTable_deleteSlot()">
                        <v-icon>
                            mdi-delete
                        </v-icon>
                    </v-btn>

                    <v-btn
                        fab
                        small
                        class="mr-6"
                        @click="onClick_slotsTable_createSlotRequest()">
                        <v-icon>
                            mdi-send
                        </v-icon>
                    </v-btn>

                    <v-btn
                        fab
                        small
                        class="mr-6"
                        @click="onClick_slotsTable_createSlot()">
                        <v-icon>
                            mdi-plus
                        </v-icon>
                    </v-btn>
                </v-speed-dial>
            </v-row>
            <!-- Slots Table -->


            <!-- Drag Bar -->
            <div
                ref="dragbarref"
                class="dragbar"
                :class="{hover: hoverDragbar}"
                @mouseover="hoverDragbar = true"
                @mouseleave="hoverDragbar = false" />
            <!-- Drag Bar -->

            <!-- Flights Table -->
            <div class="table_headline">
                <div style="">
                    Flights Table
                    ({{ get_Flights_Filtered.length }} / {{ get_Flights.length }} flights shown)
                </div>
            </div>
            <v-row
                ref="flightstablecontainerref"
                style="height:80vh;padding-bottom:210px;position:relative;"
                :style="{ height: bottomHeight + 'px' }">
                <v-col style="overflow:scroll;height:100%;padding-top:0px;">
                    <sdr-slotmanagement-flights-table :smallScreen="!$isDesktop()" :showRotation="showRotation" />
                </v-col>
                <v-speed-dial
                    v-if="showFlightsSpeedDial"
                    v-model="fabFlightsSpeedDial"
                    open-on-hover
                    style="position:absolute;bottom:220px;right:50px;">
                    <template v-slot:activator>
                        <v-btn
                            v-model="fabFlightsSpeedDial"
                            style="position:relative;"
                            color="primary"
                            fab>
                            <v-icon v-if="fabFlightsSpeedDial">
                                mdi-close
                            </v-icon>
                            <v-icon v-else>
                                mdi-plus
                            </v-icon>
                            <div class="flightsTable_selectedFlightsCounter">
                                {{ get_FlightTable_SelectedFlights.length }}
                            </div>
                        </v-btn>
                    </template>

                    <v-btn
                        fab
                        small
                        class="mr-6"
                        @click="onClick_flightsTable_flightsSlotRequest()">
                        <v-icon>
                            mdi-send
                        </v-icon>
                    </v-btn>

                    <v-btn
                        fab
                        small
                        class="mr-6"
                        @click="onClick_flightsTable_flightsEdit()">
                        <v-icon>
                            mdi-pencil
                        </v-icon>
                    </v-btn>
                </v-speed-dial>
            </v-row>
            <!-- Flights Table -->
        </v-container>
    </div>
</template>

<script>
    import Vue from 'vue';
	import { mapActions, mapGetters } from 'vuex';
    import { eventBus } from '../../../main';
    import dayjs from 'dayjs';

	import FlightsTable from './components/core/flights/FlightsTable.vue';
	import SlotsTable from './components/core/slots/SlotsTable.vue';


    export default {
        name: 'Slotmanagement',

		/* >>> *************************************************************** / /* Components */
    components: {

            SlotmanagementCoreAppBar: () => import('../slotmanagement/components/core/AppBar.vue'), // local
			'sdr-slotmanagement-flights-table': FlightsTable,
            'sdr-slotmanagement-slots-table': SlotsTable

		}, // eo components{}
		/* <<< ****************************************************************/

        /* >>> *************************************************************** / /* Props */
        props: {

            flights_dateRange: Array

        }, // eo props{}
        /* <<< ****************************************************************/


		/* >>> *************************************************************** / /* Data */
		data: function() {

			return {
				// >>>>> Drag&Drop --------------
                hoverDragbar: false,
                slotstablecontainerref: null,
                flightstablecontainerref: null,
                dragbarref: null,
                dragbarCurrentYPosition: 0,
                containerHeight: 0,

                fabSlotsSpeedDial: false,
                showSlotsSpeedDial: true,

                fabFlightsSpeedDial: false,
                showFlightsSpeedDial: true,

                dragActive: false,
                startY: 0,
                startTopHeight: 0,
                startBottomHeight: 0,
                minTopHeight: 5,
                minBottomHeight: 5,
                maxTopHeight: 95,
                maxBottomHeight: 95,
                topHeight: 50,
                bottomHeight: 50,
                // >>> Drag Div ----------------
                id: null,
                clicked: false,
                dragItem: '',
                startYCoordinate: null,
                alreadyConnectedSlot: null,

                // <<<<<
                showRotation: true // true -> 'single' or false -> 'rotation'
			};

		}, // eo function data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
		computed: {

			...mapGetters([
                'get_FlightTable_SelectedFlights',
                'get_Flights',
                'get_Flights_Filtered',
                'get_SlotsTable_SelectedSlots'
            ])

		}, // eo computed{}
		/* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

			const me = this;

			me.$toc('>>> views/slotmanagement/Home.vue >>> created');
            //listeners
            eventBus.$on('activateconnectslot', me.onClick_connectSlot);
            eventBus.$on('clearconnectingslot', me.onRemove_releaseConnectedSlot);

		}, // eo function created()
		/* <<< ****************************************************************/

		/***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function () {

            const me = this;


            me.$toc('>>> views/slotmanagement/Home.vue >>> mounted');
            window.addEventListener('resize', this.onEmit_WindowSizeChanged);
            this.onEmit_WindowSizeChanged();
            me.onEmit_setDragAndDropListeners();
            const flightstablecontainerrefHeight = parseInt(getComputedStyle(me.$refs.flightstablecontainerref, '').height);
            if (flightstablecontainerrefHeight <= 419) {
                me.showFlightsSpeedDial = false;
            }

        }, // eo function mounted()

        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;

            me.$toc('>>> views/slotmanagement/Home.vue >>> destoryed');
            //listeners
            window.removeEventListener('resize', this.onEmit_WindowSizeChanged);
            eventBus.$off('activateconnectslot', me.onClick_connectSlot);
            eventBus.$off('clearconnectingslot', me.onRemove_releaseConnectedSlot);
            me.onRemove_releaseConnectedSlot();

        }, // eo function destroyed()



        /* >>> *************************************************************** / /* Methods */
		methods: {

			...mapActions([]),

            /*******************************************************************
            * startDrag()
            *
            * Desc:
            *
            */
            startDrag: function (event) {

                const me = this;
                event.preventDefault();


                me.dragActive = true;
                me.startY = ((event.clientY) / parseInt(getComputedStyle(me.$refs.containerref, '').height)) * 100;
                me.startTopHeight = ((me.topHeight) / parseInt(getComputedStyle(me.$refs.containerref, '').height)) * 100;
                me.startBottomHeight = ((me.bottomHeight) / parseInt(getComputedStyle(me.$refs.containerref, '').height)) * 100;
                document.addEventListener('mousemove', me.handleDrag);
                document.addEventListener('mouseup', me.stopDrag);

            }, // eo function startDrag()

            /*******************************************************************
            * handleDrag()
            *
            * Desc:
            *
            */
            handleDrag: function (event) {

                const me = this,
                      deltaY = event.clientY - me.startY;

                if (!me.dragActive) {
                    return;
                }
                me.topHeight = Math.min(
                    Math.max(((me.startTopHeight + deltaY) / parseInt(getComputedStyle(me.$refs.containerref, '').height)) * 100, me.minTopHeight),
                    me.maxTopHeight
                );
                me.bottomHeight = Math.min(
                    Math.max(((me.startBottomHeight - deltaY) / parseInt(getComputedStyle(me.$refs.containerref, '').height)) * 100, me.minBottomHeight),
                    me.maxBottomHeight
                );

            }, // eo function handleDrag()

            /*******************************************************************
            * stopDrag()
            *
            * Desc:
            *
            */
            stopDrag: function (event) {

                const me = this;


                me.dragActive = false;
                document.removeEventListener('mousemove', me.handleDrag);
                document.removeEventListener('mouseup', me.stopDrag);

            }, // eo function stopDrag()

            /*******************************************************************
            * onEmit_WindowSizeChanged()
            *
            * Desc:
            *
            */
            onEmit_WindowSizeChanged: function(payload) {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onEmit_WindowSizeChanged');
                // sets new height of slots table
				me.$refs.slotstablecontainerref.style.height = '20vh';
                me.showSlotsSpeedDial = true;
                // sets new height of flights table
                me.$refs.flightstablecontainerref.style.height = '80vh';
                me.showFlightsSpeedDial = true;


            }, // eo function onEmit_WindowSizeChanged()

            /*******************************************************************
            * onClick_flightsTable_flightsEdit()
            *
            * Desc:
            * Note:
            *
            */
            onClick_flightsTable_flightsEdit: function() {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onClick_flightsTable_flightsEdit');
                eventBus.$emit('flightsEditClicked');

            }, // eo function onClick_flightsTable_flightsEdit()

            /*******************************************************************
            * onClick_flightsTable_flightsSlotRequest()
            *
            * Desc:
            * Note:
            *
            */
            onClick_flightsTable_flightsSlotRequest: function() {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onClick_flightsTable_flightsSlotRequest');
                eventBus.$emit('flightsSlotRequestClicked');

            }, // eo function onClick_flightsTable_flightsSlotRequest()

            /*******************************************************************
            * onClick_slotsTable_createSlot()
            *
            * Desc:
            * Note:
            *
            */
            onClick_slotsTable_createSlot: function() {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onClick_slotsTable_createSlot');
                eventBus.$emit('createslotclicked');

            }, // eo function onClick_slotsTable_createSlot()

            /*******************************************************************
            * onClick_slotsTable_createSlot()
            *
            * Desc:
            * Note:
            *
            */
            onClick_slotsTable_createSlotRequest: function() {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onClick_slotsTable_createSlotRequest');
                eventBus.$emit('createSlotRequest');

            }, // eo function onClick_slotsTable_createSlotRequest()

            /*******************************************************************
            * onClick_slotsTable_editSlot()
            *
            * Desc:
            * Note:
            *
            */
            onClick_slotsTable_editSlot: function() {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onClick_slotsTable_editSlot');
                if (me.get_SlotsTable_SelectedSlots.length === 0) {
                    Vue.prototype.$toasted.global.sdr_app_info({
                        message: 'No selected Slots found. Please select at least one.'
                    });
                } else {
                    eventBus.$emit('editslotclicked');
                }


            }, // eo function onClick_slotsTable_editSlot()

            /*******************************************************************
            * onClick_slotsTable_deleteSlot()
            *
            * Desc:
            * Note:
            *
            */
            onClick_slotsTable_deleteSlot: function() {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onClick_slotsTable_deleteSlot');
                eventBus.$emit('deleteslotclicked');

            }, // eo function onClick_slotsTable_deleteSlot()

			/*******************************************************************
            * onEmit_setDragAndDropListeners()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_setDragAndDropListeners: function() {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onEmit_setDragAndDropListeners');
                me.dragbarref = me.$refs.dragbarref;
                me.slotstablecontainerref = me.$refs.slotstablecontainerref;
                me.flightstablecontainerref = me.$refs.flightstablecontainerref;
                me.containerHeight = parseInt(getComputedStyle(me.$refs.containerref, '').height);

                me.dragbarref.addEventListener('mousedown', function(e) {
                    me.dragbarCurrentYPosition = e.y;

                    document.addEventListener('mousemove', me.onEmit_resizeList, false);
                }, false);

                document.addEventListener('mouseup', function() {
                    // me.hoverDragbar = false;
                    document.removeEventListener('mousedown', me.onEmit_resizeList, false);
                    document.removeEventListener('mousemove', me.onEmit_resizeList, false);
                }, false);

            }, // eo function onEmit_setDragAndDropListeners()


            /*******************************************************************
            * onEmit_resizeList()
            *
            * Desc: Calculates the new height of the Flights Table Container
            * Note:
            *
            */
            onEmit_resizeList: function(e) {

                const me = this;


                me.$toc('>>> views/slotmanagement/Home.vue >>> onEmit_resizeList');
                // prevent selection while draggin
                if (e.preventDefault) {
                    e.preventDefault();
                }
                // adds hover class if true
                me.hoverDragbar = true;
                // enable/disable float btn
                if (me.showSlotsSpeedDial === true && e.y <= 264) {
                    me.showSlotsSpeedDial = false;
                } else if (me.showSlotsSpeedDial === false && e.y >= 266) {
                    me.showSlotsSpeedDial = true;
                }
                if (me.showFlightsSpeedDial === true && ((e.y + 419) >= me.containerHeight)) {
                    me.showFlightsSpeedDial = false;
                } else if (me.showFlightsSpeedDial === false && ((e.y + 421) <= me.containerHeight)) {
                    me.showFlightsSpeedDial = true;
                }
                // safe space (top || bottom)
                if ((e.y <= 180) || ((e.y + 200) > me.containerHeight)) {
                    return;
                }
                // sets new height of slots table
				me.slotstablecontainerref.style.height = (e.y - 130) + 'px';
                // sets new height of flights table
                me.flightstablecontainerref.style.height = (me.containerHeight - e.y) + 'px';


            }, // eo function onEmit_resizeList()



            /*******************************************************************
            * onClick_connectSlot()
            *
            * Desc: Selects or deleselects the clicked slot and 'creates' the to
            * Desc: the cursor attached 'Slot-Pill' with core information in it
            * Note:
            *
            */
            onClick_connectSlot: function(items) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/SlotTableItem.vue >>> onClick_connectSlot');
                if (!items) {
                    return;
                }
                if (items.slot.id === me.id) {
                    me.onRemove_releaseConnectedSlot();
                    return;
                }
                // sets the id of the slot to find the correct clicked slot based on the element-id
                me.id = items.slot.id;
                // activationfor .clicked class
                me.clicked = true;
                //core information
                me.dragItem = `${items.slot.airportSlot} ${items.slot.flightNo} ${dayjs(items.slot.slotTime).format('DDMMM').toUpperCase()} ${items.dow} ${items.aircraft} ${items.slotAptTime}`;
                eventBus.$emit('selectedconntectslot', items.slot);
                document.addEventListener('mousemove', me.onMouseMove_moveConnectedSlot, false);
                document.addEventListener('keyup', function(ev) {
                    if (ev.code === 'Escape') {
                        me.onRemove_releaseConnectedSlot();
                    }
                });

            }, // eo function onClick_connectSlot()

            /*******************************************************************
            * onMouseMove_moveConnectedSlot()
            *
            * Desc: Attaches the selected Slot to the cursor
            * Note:
            *
            */
            onMouseMove_moveConnectedSlot: function(ev) {

                const me = this;

                if (me.startYCoordinate === null) {
                    me.startYCoordinate = ev.clientY;
                }
                //me.clicked = true;
                document.getElementById(me.id).style.transform = 'translateY(' + (ev.clientY - 80) + 'px)';
                document.getElementById(me.id).style.transform += 'translateX(' + (ev.clientX - 410) + 'px)';

            }, // eo function onMouseMove_moveConnectedSlot()

            /*******************************************************************
            * onRemove_releaseConnectedSlot()
            *
            * Desc: Releases the dragged slot from cursor
            * Note:
            *
            */
            onRemove_releaseConnectedSlot: function(slot) {

                const me = this;


                me.$toc('>>> views/flights/slotmanagement/components/core/slots/SlotTableItem.vue >>> onRemove_releaseConnectedSlot');
                me.id = null;
                me.clicked = false;
                me.dragItem = '';
                eventBus.$emit('selectedconntectslot', null);
                document.removeEventListener('mousemove', me.onMouseMove_moveConnectedSlot, false);

            } // eo function onRemove_releaseConnectedSlot()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>


<style scoped>

.dragbar {
    width:100%;
    padding: 3px 0;
    background-color:#e5e5e8;
    text-align:center;
    cursor:ns-resize;
    border-top: 3px solid #eeeeee;
    border-bottom: 3px solid #eeeeee;
    z-index: 100;
}

.hover {
    border-top: 3px solid #e5e5e8;
    border-bottom: 3px solid #e5e5e8;
}

.table_headline {
    position: sticky;
    top:0;
    font-size: 18px;
    height: 15px;
    padding: 22px 22px;
    display: flex;
    align-items: center;
    font-size:1rem;
    margin-left:8px;
    display:flex;
    justify-content: space-between;

}

.flightsTable_selectedFlightsCounter {
    position:absolute;
    top:-14px;
    right:-14px;
    width:30px;
    height:30px;
    background-color:#ab3b7a;
    border-radius:50%;
    display:flex;
    align-items:center;
    justify-content:center;
    font-weight: 500;
}

 .clicked {
        position: fixed !important; /* Floating above */
        transition: transform 0.13s; /* Sticking effect */
        pointer-events: none; /* Allow clicking trough the div */
        z-index: 1000;
        visibility:visible ;
        background-color: rgba(255, 255, 255, 0.631);
        padding: 10px;
        border-radius: 25px;
    }
.background {
    filter: blur(4px);
    position: absolute;
    width: 100%;
    height: 100%;
}
.foreground {
  backdrop-filter: blur(10px);
} /* No .wrapper needed! */

    .dragdiv {
        visibility:hidden;
        height: 0px;
    }

</style>

